import React from "react";
import { Route, Routes } from "react-router-dom";
import HomeRedirect from "./containers/HomeRedirect";
import Login from "./containers/Login";
import BoardTableLayout from "./containers/BoardTableLayout";
import DocumentsList from "./containers/DocumentsList";
import DemandesList from "./containers/DemandesList";
import DemandesHistoriquesList from "./containers/DocumentsAchetesUtilisateursList";
import HistoriquesRepresentantsList from "./containers/HistoriquesRepresentantsList";
import CommandesAchatsList from "./containers/CommandesAchatsList";
import SignedOutHOC from "./containers/SignedOutHoc";
import SignedInHOC from "./containers/SignedInHoc";
import UploadDocument from "./containers/UploadDocument";
import ForgotPassword from "./containers/ForgotPassword";
import ResetPassword from "./containers/ResetPassword";
import TermsAndConditions from "./containers/TermsAndConditions";
import Settings from "./containers/Settings";
import DocumentDetails from "./containers/DocumentDetails";
import DemandDetails from "./containers/DemandesDetails";
import CommandesAchatsDetails from "./containers/CommandesAchatsDetails";
import DocumentsAchetesUtilisateursDetails from "./containers/DocumentsAchetesUtilisateursDetails";
import Help from "./containers/Help";
import Faq from "./containers/Faq";
import HistoriquesRepresentantsDetails from "./containers/HistoriquesRepresentantsDetails";
import OffresGroupes from "./containers/OffresGroupes";
import OffresGroupesDetails from "./containers/OffresGroupesDetails";
import AdminTelechargements from "./containers/AdminTelechargements";
import Err404 from "./containers/Err404";
import { far } from "@fortawesome/free-regular-svg-icons";
import { faSpinner, faCheck } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import "./aws-configs"; // Configuration is applied on import

library.add(far, faSpinner, faCheck);

const AppRoutes = (props) => {
  const SignedInBoardTableLayout = SignedInHOC(BoardTableLayout);
  const SignedInUploadDocument = SignedInHOC(UploadDocument);
  const SignedInDocumentsList = SignedInHOC(DocumentsList);
  const SignedInDocumentDetails = SignedInHOC(DocumentDetails);
  const SignedInDemandesList = SignedInHOC(DemandesList);
  const SignedInDemandDetails = SignedInHOC(DemandDetails);
  const SignedInDemandesHistoriquesList = SignedInHOC(DemandesHistoriquesList);
  const SignedInDocumentsAchetesUtilisateursDetails = SignedInHOC(DocumentsAchetesUtilisateursDetails);
  const SignedInCommandesAchatsList = SignedInHOC(CommandesAchatsList);
  const SignedInCommandesAchatsDetails = SignedInHOC(CommandesAchatsDetails);
  const SignedInHistoriquesRepresentantsList = SignedInHOC(HistoriquesRepresentantsList);
  const SignedInHistoriquesRepresentantsDetails = SignedInHOC(HistoriquesRepresentantsDetails);
  const SignedInSettings = SignedInHOC(Settings);
  const SignedInOffresGroupes = SignedInHOC(OffresGroupes);
  const SignedInOffresGroupesDetails = SignedInHOC(OffresGroupesDetails);
  const SignedInAdminTelechargements = SignedInHOC(AdminTelechargements);
  const SignedInTermsAndConditions = SignedInHOC(TermsAndConditions);
  const SignedInHelp = SignedInHOC(Help);
  const SignedInFaq = SignedInHOC(Faq);
  const SignedOutLogin = SignedOutHOC(Login);
  const SignedOutForgotPassword = SignedOutHOC(ForgotPassword);
  const SignedOutResetPassword = SignedOutHOC(ResetPassword);

  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/tableau-de-bord" element={<SignedInBoardTableLayout />} />
      <Route path="/home" element={<HomeRedirect />} />
      <Route path="/connexion" element={<SignedOutLogin />} />
      <Route path="/produits-deposer" element={<SignedInUploadDocument />} />
      <Route path="/connexion/forgotpassword" element={<SignedOutForgotPassword />} />
      <Route path="/connexion/resetpassword" element={<SignedOutResetPassword />} />
      <Route path="/produits" element={<SignedInDocumentsList />} />
      <Route path="/produits-details/:id" element={<SignedInDocumentDetails />} />
      <Route path="/demandes" element={<SignedInDemandesList />} />
      <Route path="/demandes-details/:id/:statut" element={<SignedInDemandDetails />} />
      <Route path="/historique-achats-produits" element={<SignedInDemandesHistoriquesList />} />
      <Route path="/historique-achats-produits-details/:id" element={<SignedInDocumentsAchetesUtilisateursDetails />} />
      <Route path="/bons-de-commande" element={<SignedInCommandesAchatsList />} />
      <Route path="/commande-details/:id" element={<SignedInCommandesAchatsDetails />} />
      <Route path="/historique-achats-representants" element={<SignedInHistoriquesRepresentantsList />} />
      <Route path="/historique-achats-representants-details/:id" element={<SignedInHistoriquesRepresentantsDetails />} />
      <Route path="/parametres" element={<SignedInSettings />} />
      <Route path="/offres-groupes" element={<SignedInOffresGroupes />} />
      <Route path="/offres-groupes-details/:id" element={<SignedInOffresGroupesDetails />} />
      <Route path="/offres-groupes-details" element={<SignedInOffresGroupesDetails />} />
      <Route path="/reinitialiser-telechargements" element={<SignedInAdminTelechargements />} />
      <Route path="/conditions-d-acces" element={<SignedInTermsAndConditions />} />
      <Route path="/aide" element={<SignedInHelp />} />
      <Route path="/faq" element={<SignedInFaq />} />
      <Route path="*" element={<Err404 />} />
    </Routes>
  );
};

export default AppRoutes;
